module.exports = __webpack_public_path__ + "img/works_kiwoom_btm_off.c1e10af5.png";